import { Injectable, inject } from '@angular/core';
import { AuthState } from '../../states/auth.state';

/**
 * Set Access Token Use Case
 *
 * Sets the access token in the auth state.
 * Used by login components and authentication flows.
 */
@Injectable({ providedIn: 'root' })
export class SetAccessTokenUseCase {
  private readonly _authState = inject(AuthState);

  /**
   * Execute the use case
   * @param token - The access token
   */
  public execute(token: string): void {
    this._authState.setAccessToken(token);
  }
}
